import React, { useEffect, useState } from "react";
import { connect,useDispatch,useSelector } from "react-redux";
import { Redirect,useHistory  } from 'react-router-dom'
import logoJuegodelaBolsa from '../../image/logoJuegodelaBolsa2.svg';
import logoBVQ from '../../image/logoBVQ2.svg';
import {enableFuncionalityForRole} from "../general/Util"
import { setStatusByKey } from "../../actions/juego";
import {NotificationContainer} from "react-notifications";

import { logout } from "../../actions/auth";
import {formatTime} from "./Util"
import ConfigurarUsuario from "./ConfigurarUsuario"
import ConfigurarEvento from "./ConfigurarEvento"
import AdministracionEvento from "./AdministracionEvento"
import GestionUsuario from "./GestionUsuario";											  
import GestionNoticias from "./GestionNoticias";
import GestionCatalogo from "./GestionCatalogo";
import GestionTitulos from "./GestionTitulos";
import GestionParametros from "./GestionParametros";
import EventoPlantilla from "./EventoPlantilla";
import CajaNegociacion from "../CajaNegociacion";
import CajaPortafolio from "../CajaPortafolio";
import Banner from "./Banner";

import {getEventosPorUsuario} from "../../actions/juego";

import {
    Menu,
    MenuItem,
    MenuButton,SubMenu
} from '@szhsin/react-menu';
import '@szhsin/react-menu/dist/index.css';


const Header = (props) => {    
    const { user: currentUser } = useSelector((state) => state.auth);
    const { listEventos: currentEventos,showLablesTime,eventoSeleccionado,modalidadCodigo,muteAudioGen,enableAudio10seg } = useSelector((state) => state.juego);

    let [timerHeader, setTimerHeader] = useState(0);
    let [timerJugHeader, setTimerJugHeader] = useState(0);
    let [lastTimerJugHeader, setLastTimerJugHeader] = useState(0);    
    let [openProfile, setOpenProfile] = useState(false);    
    let [openConfigEvent, setOpenConfigEvent] = useState(false);    
	let [openNewEvent, setOpenNewEvent] = useState(false);    
    let [openUser, setOpenUser] = useState(false);
    let [openNoticias, setOpenNoticias] = useState(false);
    let [openCatalogos,setOpenCatalogos] = useState(false);
    let [openTitulos, setOpenTitulos] = useState(false);
    let [openParametros,setOpenParametros] = useState(false);
    let [openEventoPlantilla,setOpenEventoPlantilla] = useState(false);
    let [openBanner,setOpenBanner]=useState(false);
    let [openNegociacion,setOpenNegociacion]=useState(false);    
    let [openPortafolio,setOpenPortafolio]=useState(false);        
    
    let [gestionUser] = useState(true);  	
    let [configEvento] = useState(currentUser!==null?enableFuncionalityForRole(currentUser["role"],"CONF_EVENTO"):false);  
    let [admFuncionality] = useState(currentUser!==null?enableFuncionalityForRole(currentUser["role"],"FUNC_ADM"):false);  
    let [cajaFuncionality] = useState(currentUser!==null && window.location.pathname==="/sala"?enableFuncionalityForRole(currentUser["role"],"FUNC_CAJ"):false);
    let [openVentana,setOpenVentana] = useState(false);
    let [autoPlayCheck,setAutoPlayCheck] = useState(true);

    
    if(cajaFuncionality===true && window.location.pathname!=="/sala"){
        cajaFuncionality = false
    }

    if(autoPlayCheck===true){
        setAutoPlayCheck(false)
        checkAutoPlay()
    }
    
    let history = useHistory();
    const dispatch = useDispatch();

    const openProfileClick = () => {
        setOpenProfile(true)

        setOpenConfigEvent(false)
        setOpenNewEvent(false)
        setOpenUser(false)
        setOpenNoticias(false)
        setOpenCatalogos(false)
        setOpenTitulos(false)
        setOpenParametros(false)
        setOpenEventoPlantilla(false)
        setOpenBanner(false)
    }; 
    const closeProfileClick = () => {
        setOpenProfile(false)
    };
    const showEventos = () =>{
        history.push('/sala') 
    }

    const logOut = () => {
        dispatch(logout());        
    }; 
    const silenceAudio = () => {
        if(muteAudioGen===true)
        {            
            try{
            document.getElementById('playAudioGen').play()            
            }catch(ex){

            }
        }   
        dispatch(setStatusByKey("muteAudioGen",!muteAudioGen))
    };     
    const configurarEvento = () =>{
        setOpenConfigEvent(true)
    }
    const closeConfigEventClick = () =>{
        setOpenConfigEvent(false)
    }
	const administracionEvento = () =>{
        setOpenNewEvent(true)

        setOpenPortafolio(false)
        setOpenNegociacion(false)
        setOpenProfile(false)
        setOpenConfigEvent(false)
        setOpenUser(false)
        setOpenNoticias(false)
        setOpenCatalogos(false)
        setOpenTitulos(false)
        setOpenParametros(false)
        setOpenEventoPlantilla(false)
        setOpenBanner(false)
    }
	const gestionUsuarioOpen = ()=>{
        setOpenUser(true)
        setOpenPortafolio(false)
        setOpenNegociacion(false)
        setOpenNewEvent(false)
        setOpenProfile(false)
        setOpenConfigEvent(false)
        setOpenNoticias(false)
        setOpenCatalogos(false)
        setOpenTitulos(false)
        setOpenParametros(false)
        setOpenEventoPlantilla(false)
        setOpenBanner(false)
    }
    const eventoPlantillaOpen = ()=>{
        setOpenEventoPlantilla(true)

        setOpenPortafolio(false)
        setOpenNegociacion(false)
        setOpenUser(false)
        setOpenNewEvent(false)
        setOpenProfile(false)
        setOpenConfigEvent(false)
        setOpenNoticias(false)
        setOpenCatalogos(false)
        setOpenTitulos(false)
        setOpenParametros(false)
        setOpenBanner(false)
    }
    const closeEventoPlantillaClick= ()=>{
        setOpenEventoPlantilla(false)
    }
    const bannerOpen = () =>{
        setOpenBanner(true)

        setOpenPortafolio(false)
        setOpenNegociacion(false)
        setOpenEventoPlantilla(false)
        setOpenUser(false)
        setOpenNewEvent(false)
        setOpenProfile(false)
        setOpenConfigEvent(false)
        setOpenNoticias(false)
        setOpenCatalogos(false)
        setOpenTitulos(false)
        setOpenParametros(false)
    }
    const closeBannerClick = ()=>{
        setOpenBanner(false)
    }
    const gestionNoticiasOpen = ()=>{
        setOpenNoticias(true)

        setOpenPortafolio(false)
        setOpenNegociacion(false)
        setOpenEventoPlantilla(false)
        setOpenUser(false)
        setOpenNewEvent(false)
        setOpenProfile(false)
        setOpenConfigEvent(false)
        setOpenCatalogos(false)
        setOpenTitulos(false)
        setOpenParametros(false)
        setOpenBanner(false)
    }
    const gestionTitulosOpen = ()=>{
        setOpenTitulos(true)

        setOpenPortafolio(false)
        setOpenNegociacion(false)
        setOpenEventoPlantilla(false)
        setOpenUser(false)
        setOpenNewEvent(false)
        setOpenProfile(false)
        setOpenConfigEvent(false)
        setOpenNoticias(false)
        setOpenCatalogos(false)
        setOpenParametros(false)
        setOpenBanner(false)
    }
    
    const closeGestionUsuariosClick = ()=>{
        setOpenUser(false)
    }
    const closeGestionNoticiasClick = ()=>{
        setOpenNoticias(false)
    }    
    const closeNewEventClick = () =>{
        setOpenNewEvent(false)
    }
    const gestionCatalogosOpen = ()=>{
        setOpenCatalogos(true)

        setOpenPortafolio(false)
        setOpenNegociacion(false)
        setOpenEventoPlantilla(false)
        setOpenUser(false)
        setOpenNewEvent(false)
        setOpenProfile(false)
        setOpenConfigEvent(false)
        setOpenNoticias(false)
        setOpenTitulos(false)
        setOpenParametros(false)
        setOpenBanner(false)
    }
    const closeGestionCatalogoClick = ()=>{
        setOpenCatalogos(false)
    }
    const closeGestionParametrosClick = ()=>{
        setOpenParametros(false)
    }
    const gestionParametrosOpen = ()=>{
        setOpenParametros(true)
        setOpenPortafolio(false)
        setOpenNegociacion(false)
        setOpenEventoPlantilla(false)
        setOpenUser(false)
        setOpenNewEvent(false)
        setOpenProfile(false)
        setOpenConfigEvent(false)
        setOpenNoticias(false)
        setOpenCatalogos(false)
        setOpenTitulos(false)
        setOpenBanner(false)
    }
    const ingresoOrdenOpen =()=>{
        setOpenNegociacion(true)        
        setOpenPortafolio(false)

        setOpenParametros(false)
        setOpenEventoPlantilla(false)
        setOpenUser(false)
        setOpenNewEvent(false)
        setOpenProfile(false)
        setOpenConfigEvent(false)
        setOpenNoticias(false)
        setOpenCatalogos(false)
        setOpenTitulos(false)
        setOpenBanner(false)
    }
    const portafolioOpen =()=>{
        setOpenPortafolio(true)
        
        setOpenNegociacion(false)        
        setOpenParametros(false)
        setOpenEventoPlantilla(false)
        setOpenUser(false)
        setOpenNewEvent(false)
        setOpenProfile(false)
        setOpenConfigEvent(false)
        setOpenNoticias(false)
        setOpenCatalogos(false)
        setOpenTitulos(false)
        setOpenBanner(false)
    }
    

    const closeGestionTitulosClick = ()=>{
        setOpenTitulos(false)
    }    
    const seleccionarEvento = () => {
        dispatch(getEventosPorUsuario(currentUser["userId"]))
        .then(() => {               
        })
        .catch(() => {
        });
        dispatch(setStatusByKey("forceSelectEvento",true))
        history.push('/seleccionar') 
    }
    let closeWindows = () =>{

    }
    useEffect(() => {
        if(window.location.pathname==="/sala"){
            const timer=setTimeout(() => {    
            
                setTimerHeader(timerHeader => timerHeader + 1);
            }, 1000);
            
            return () => clearTimeout(timer);
        }        
    });

    useEffect(() => {
        if(window.location.pathname==="/sala"){
            const timerDown=setTimeout(() => {            
                setTimerJugHeader(timerJugHeader => timerJugHeader - 1);
                
                if(timerJugHeader===20 && enableAudio10seg===true)
                    dispatch(setStatusByKey("srcAudioAct",global.config.URL_AUDIO + "20segundos.mp3"))
    
                if(timerJugHeader<=11 && timerJugHeader>1 && enableAudio10seg===true)
                    dispatch(setStatusByKey("srcAudioAct",global.config.URL_AUDIO + (timerJugHeader-1) + ".mp3"))    
                
            }, 1000);
            
            return () => clearTimeout(timerDown);
        }        
    });

    function start(){
        setTimerHeader(props.allTime)
    }
    function startJugada(){        
        setLastTimerJugHeader(props.timeLastPlay)
        setTimerJugHeader(props.timeLastPlay)        
    }
    function checkAutoPlay(){
        var mp3 = 'data:audio/mpeg;base64,/+MYxAAAAANIAUAAAASEEB/jwOFM/0MM/90b/+RhST//w4NFwOjf///PZu////9lns5GFDv//l9GlUIEEIAAAgIg8Ir/JGq3/+MYxDsLIj5QMYcoAP0dv9HIjUcH//yYSg+CIbkGP//8w0bLVjUP///3Z0x5QCAv/yLjwtGKTEFNRTMuOTeqqqqqqqqqqqqq/+MYxEkNmdJkUYc4AKqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqq';
    
        var ogg = 'data:audio/ogg;base64,T2dnUwACAAAAAAAAAADqnjMlAAAAAOyyzPIBHgF2b3JiaXMAAAAAAUAfAABAHwAAQB8AAEAfAACZAU9nZ1MAAAAAAAAAAAAA6p4zJQEAAAANJGeqCj3//////////5ADdm9yYmlzLQAAAFhpcGguT3JnIGxpYlZvcmJpcyBJIDIwMTAxMTAxIChTY2hhdWZlbnVnZ2V0KQAAAAABBXZvcmJpcw9CQ1YBAAABAAxSFCElGVNKYwiVUlIpBR1jUFtHHWPUOUYhZBBTiEkZpXtPKpVYSsgRUlgpRR1TTFNJlVKWKUUdYxRTSCFT1jFloXMUS4ZJCSVsTa50FkvomWOWMUYdY85aSp1j1jFFHWNSUkmhcxg6ZiVkFDpGxehifDA6laJCKL7H3lLpLYWKW4q91xpT6y2EGEtpwQhhc+211dxKasUYY4wxxsXiUyiC0JBVAAABAABABAFCQ1YBAAoAAMJQDEVRgNCQVQBABgCAABRFcRTHcRxHkiTLAkJDVgEAQAAAAgAAKI7hKJIjSZJkWZZlWZameZaouaov+64u667t6roOhIasBACAAAAYRqF1TCqDEEPKQ4QUY9AzoxBDDEzGHGNONKQMMogzxZAyiFssLqgQBKEhKwKAKAAAwBjEGGIMOeekZFIi55iUTkoDnaPUUcoolRRLjBmlEluJMYLOUeooZZRCjKXFjFKJscRUAABAgAMAQICFUGjIigAgCgCAMAYphZRCjCnmFHOIMeUcgwwxxiBkzinoGJNOSuWck85JiRhjzjEHlXNOSuekctBJyaQTAAAQ4AAAEGAhFBqyIgCIEwAwSJKmWZomipamiaJniqrqiaKqWp5nmp5pqqpnmqpqqqrrmqrqypbnmaZnmqrqmaaqiqbquqaquq6nqrZsuqoum65q267s+rZru77uqapsm6or66bqyrrqyrbuurbtS56nqqKquq5nqq6ruq5uq65r25pqyq6purJtuq4tu7Js664s67pmqq5suqotm64s667s2rYqy7ovuq5uq7Ks+6os+75s67ru2rrwi65r66os674qy74x27bwy7ouHJMnqqqnqq7rmarrqq5r26rr2rqmmq5suq4tm6or26os67Yry7aumaosm64r26bryrIqy77vyrJui67r66Ys67oqy8Lu6roxzLat+6Lr6roqy7qvyrKuu7ru+7JuC7umqrpuyrKvm7Ks+7auC8us27oxuq7vq7It/KosC7+u+8Iy6z5jdF1fV21ZGFbZ9n3d95Vj1nVhWW1b+V1bZ7y+bgy7bvzKrQvLstq2scy6rSyvrxvDLux8W/iVmqratum6um7Ksq/Lui60dd1XRtf1fdW2fV+VZd+3hV9pG8OwjK6r+6os68Jry8ov67qw7MIvLKttK7+r68ow27qw3L6wLL/uC8uq277v6rrStXVluX2fsSu38QsAABhwAAAIMKEMFBqyIgCIEwBAEHIOKQahYgpCCKGkEEIqFWNSMuakZM5JKaWUFEpJrWJMSuaclMwxKaGUlkopqYRSWiqlxBRKaS2l1mJKqcVQSmulpNZKSa2llGJMrcUYMSYlc05K5pyUklJrJZXWMucoZQ5K6iCklEoqraTUYuacpA46Kx2E1EoqMZWUYgupxFZKaq2kFGMrMdXUWo4hpRhLSrGVlFptMdXWWqs1YkxK5pyUzDkqJaXWSiqtZc5J6iC01DkoqaTUYiopxco5SR2ElDLIqJSUWiupxBJSia20FGMpqcXUYq4pxRZDSS2WlFosqcTWYoy1tVRTJ6XFklKMJZUYW6y5ttZqDKXEVkqLsaSUW2sx1xZjjqGkFksrsZWUWmy15dhayzW1VGNKrdYWY40x5ZRrrT2n1mJNMdXaWqy51ZZbzLXnTkprpZQWS0oxttZijTHmHEppraQUWykpxtZara3FXEMpsZXSWiypxNhirLXFVmNqrcYWW62ltVprrb3GVlsurdXcYqw9tZRrrLXmWFNtBQAADDgAAASYUAYKDVkJAEQBAADGMMYYhEYpx5yT0ijlnHNSKucghJBS5hyEEFLKnINQSkuZcxBKSSmUklJqrYVSUmqttQIAAAocAAACbNCUWByg0JCVAEAqAIDBcTRNFFXVdX1fsSxRVFXXlW3jVyxNFFVVdm1b+DVRVFXXtW3bFn5NFFVVdmXZtoWiqrqybduybgvDqKqua9uybeuorqvbuq3bui9UXVmWbVu3dR3XtnXd9nVd+Bmzbeu2buu+8CMMR9/4IeTj+3RCCAAAT3AAACqwYXWEk6KxwEJDVgIAGQAAgDFKGYUYM0gxphhjTDHGmAAAgAEHAIAAE8pAoSErAoAoAADAOeecc84555xzzjnnnHPOOeecc44xxhhjjDHGGGOMMcYYY4wxxhhjjDHGGGOMMcYYY0wAwE6EA8BOhIVQaMhKACAcAABACCEpKaWUUkoRU85BSSmllFKqFIOMSkoppZRSpBR1lFJKKaWUIqWgpJJSSimllElJKaWUUkoppYw6SimllFJKKaWUUkoppZRSSimllFJKKaWUUkoppZRSSimllFJKKaWUUkoppZRSSimllFJKKaWUUkoppZRSSimllFJKKaVUSimllFJKKaWUUkoppRQAYPLgAACVYOMMK0lnhaPBhYasBAByAwAAhRiDEEJpraRUUkolVc5BKCWUlEpKKZWUUqqYgxBKKqmlklJKKbXSQSihlFBKKSWUUkooJYQQSgmhlFRCK6mEUkoHoYQSQimhhFRKKSWUzkEoIYUOQkmllNRCSB10VFIpIZVSSiklpZQ6CKGUklJLLZVSWkqpdBJSKamV1FJqqbWSUgmhpFZKSSWl0lpJJbUSSkklpZRSSymFVFJJJYSSUioltZZaSqm11lJIqZWUUkqppdRSSiWlkEpKqZSSUmollZRSaiGVlEpJKaTUSimlpFRCSamlUlpKLbWUSkmptFRSSaWUlEpJKaVSSksppRJKSqmllFpJKYWSUkoplZJSSyW1VEoKJaWUUkmptJRSSymVklIBAEAHDgAAAUZUWoidZlx5BI4oZJiAAgAAQABAgAkgMEBQMApBgDACAQAAAADAAAAfAABHARAR0ZzBAUKCwgJDg8MDAAAAAAAAAAAAAACAT2dnUwAEAAAAAAAAAADqnjMlAgAAADzQPmcBAQA=';
    
        try {
            var audio = new Audio();
            var src = audio.canPlayType('audio/ogg') ? ogg : mp3;
            audio.autoplay = true;
            audio.volume = 0;
    
            audio.src = src;
            var playPromise = audio.play();
            if (playPromise !== undefined) {
                playPromise.then(function () {	
                    dispatch(setStatusByKey("muteAudioGen",false))
                })
                .catch(function () {
                    dispatch(setStatusByKey("muteAudioGen",true))
                });
            }		
        } catch(e) {
            console.log('[AUTOPLAY-ERROR]', e);
        }
    }
    function habilitaAyuda(){
        dispatch(setStatusByKey("habilitarAyudas",true))
    }
    const btnNegociacionCancelar =()=>{
        setOpenNegociacion(false)        
    }
    const btnCerrarPortafolio =()=>{
        setOpenPortafolio(false)        
    }
    
    if(window.location.pathname!=="/recuperar" && window.location.pathname!=="/condiciones" && window.location.pathname!=="/autologin" && !currentUser){
        return <Redirect to="/login" />;
    }

  return (
    <div>   
        {
            props.allTime>timerHeader?start():""
        }   
        {
            props.timeLastPlay!==lastTimerJugHeader?startJugada():""
        }                       
        {openProfile===true?<ConfigurarUsuario closeProfileClick={closeProfileClick} openProfile={openProfile}/>:""}
        {openConfigEvent===true?<ConfigurarEvento closeConfigEventClick={closeConfigEventClick} openConfigEvent={openConfigEvent}/>:""}
		{openNewEvent===true?<AdministracionEvento closeNewEventClick={closeNewEventClick} openNewEvent={openNewEvent} />:""}	
		{openUser===true? <GestionUsuario closeGestionUsuariosClick={closeGestionUsuariosClick}/>:""}	
        {openNoticias===true? <GestionNoticias closeGestionNoticiasClick={closeGestionNoticiasClick}/>:""}	
        {openCatalogos===true? <GestionCatalogo closeGestionCatalogoClick={closeGestionCatalogoClick}/>:""}	
        {openTitulos===true? <GestionTitulos closeGestionTitulosClick={closeGestionTitulosClick}/>:""}	
        {openParametros===true? <GestionParametros closeGestionParametrosClick={closeGestionParametrosClick}/>:""}	
        {openEventoPlantilla===true? <EventoPlantilla closeEventoPlantillaClick={closeEventoPlantillaClick}/>:""}	
        {openBanner===true?<Banner closeBannerClick={closeBannerClick} />:""}
        {openNegociacion===true?<CajaNegociacion btnNegociacionCancelar={btnNegociacionCancelar}/>:""}
        {openPortafolio===true?<CajaPortafolio btnCerrarPortafolio={btnCerrarPortafolio}/>:""}
        {currentUser ? ( <div className="headerContainer">
            <div className="header">
                <div className="headerLeft ayudaUsuarioPer">                    
                    <div className="headerLeftContent">
                    <div className="boxContainer">
                    <Menu menuButton={<MenuButton>{currentUser!==null && currentUser["fileNombreUrl"]!==null && currentUser["fileNombreUrl"]!==""?<img className='imagen-profile' src={global.config.URL_UPLOAD + currentUser["fileNombreUrl"]}></img>:<i className="far fa-user bgBlue"></i>}</MenuButton>}>
                        <MenuItem onClick={openProfileClick}><i className="fas fa-address-card"></i> Perfil</MenuItem>                        
                        <MenuItem onClick={showEventos}><i className="fas fa-address-card"></i>Ir al evento</MenuItem>
						<MenuItem onClick={logOut}><i className="fas fa-sign-out-alt"></i> Cerrar sesion</MenuItem>                                                            
                    </Menu>                        
                    </div>                    
                    <div className="usernameTxt">{currentUser!==null ?currentUser["displayName"]:""}<span>{currentEventos!=null && eventoSeleccionado>0 && currentEventos.filter(value => value["EventoId"] === eventoSeleccionado).length>0?currentEventos.filter(value => value["EventoId"] === eventoSeleccionado)[0]["NombreEvento"]:"No tienes eventos activos"}</span></div>   
                    </div>
                </div>
                <div className="headerMid">
                    <div className="logoEljuegodelaBolsa headerLogo1"><img src={logoJuegodelaBolsa} alt="El Juego de la Bolsa" /></div>
                    <div className="divider"></div>
                    <div className="logoBVQ headerLogo2"><img src={logoBVQ} alt="Bolsa de Valores de Quito" /></div>    
                </div>
                <div className="headerRight">
                    <ul>
                        <li className={["timeRightContent",showLablesTime===false?"displaynone":""].join(' ')}>
                            <div className={["timeProximaJugada",modalidadCodigo==="" || modalidadCodigo!=="VIRTUAL"?"displaynone1":""].join(' ')}><span>Finaliza Jugada:</span> {formatTime(timerJugHeader)} <i className="fas fa-clock"></i></div>
                            <div className="timeTotal"><span>Tiempo Total:</span> {formatTime(timerHeader)} <i className="fas fa-clock"></i></div>
                        </li>
                        <li>
                            <div className="pasoConfig boxContainer">                                
                                <Menu menuButton={<MenuButton><i className="fas fa-cog bgBlue"></i></MenuButton>}>
                                    {configEvento===true?<MenuItem onClick={seleccionarEvento}><i className="fas fa-sign-out-alt"></i> Seleccionar evento</MenuItem>:""}
                                    {admFuncionality===true?<MenuItem onClick={administracionEvento}><i className="fas fa-sign-out-alt"></i> Configurar evento</MenuItem>:""}
                                    {admFuncionality===true?<MenuItem onClick={bannerOpen}><i className="fas fa-sign-out-alt"></i>Banner</MenuItem>:""}
                                    {admFuncionality===true?<MenuItem onClick={gestionCatalogosOpen}><i className="fas fa-sign-out-alt"></i>Catálogos</MenuItem>:""}									
                                    {admFuncionality===true?<MenuItem onClick={gestionNoticiasOpen}><i className="fas fa-sign-out-alt"></i> Noticias</MenuItem>:""}
                                    {admFuncionality===true?<MenuItem onClick={gestionParametrosOpen}><i className="fas fa-sign-out-alt"></i>Parámetros</MenuItem>:""}
                                    {admFuncionality===true?<MenuItem onClick={eventoPlantillaOpen}><i className="fas fa-sign-out-alt"></i>Plantilla juego</MenuItem>:""}
                                    {admFuncionality===true?<MenuItem onClick={gestionTitulosOpen}><i className="fas fa-sign-out-alt"></i> Títulos</MenuItem>:""}
                                    {admFuncionality===true?<MenuItem onClick={gestionUsuarioOpen}><i className="fas fa-sign-out-alt"></i> Usuarios</MenuItem>:""}
                                    {cajaFuncionality===true?<MenuItem onClick={ingresoOrdenOpen}><i className="fas fa-sign-out-alt"></i> Ingreso Ordenes</MenuItem>:""}
                                    {cajaFuncionality===true?<MenuItem onClick={portafolioOpen}><i className="fas fa-sign-out-alt"></i> Ver Portafolio</MenuItem>:""}
                                    <MenuItem onClick={showEventos}><i className="fas fa-sign-out-alt"></i>Ir al evento</MenuItem>                        
                                    <MenuItem onClick={logOut}><i className="fas fa-sign-out-alt"></i> Cerrar sesion</MenuItem>                                                            
                                </Menu>                      
                            </div>
                        </li>
                        <li className="soundContent">
                            <div className="pasoSound boxContainer">
                                <i className={["fas",muteAudioGen===true?"bgRed fa-volume-off":"fa-volume-up bgGreen"].join(' ')} onClick={silenceAudio}></i>
                            </div>
                        </li>
                        <li>
                            <div className="pasoAyuda boxContainer">
                                <i className="fas fa-question bgRed" onClick={habilitaAyuda}></i>
                            </div>
                        </li>
                    </ul>
                
                </div>
            </div>
        </div>        
        ) : (
        <div>
        </div>
        )    
    } 
    <NotificationContainer />
    </div>
  );
};

const mapStateToProps = state => ({
    allTime: state.juego.allTime,
    timeLastPlay: state.juego.timeLastPlay,
  });
  export default connect(mapStateToProps, {    
  })(Header);